// extracted by mini-css-extract-plugin
module.exports = {"box":"filed-message_box__2Hvt9","boxRed":"filed-message_boxRed__3rqiD"};